import {MarkdownRenderer} from '@github-ui/copilot-markdown'
import {clsx} from 'clsx'
import styles from '../AhpTurnView.module.css'
import type {CopilotResultRenderIdentity} from '@github-ui/copilot-browser-latency/copilot-result-presentation'
import {useCopilotResultElement} from '@github-ui/copilot-browser-latency/use-copilot-result-presentation'
import {useMergedRefs} from '@primer/react'

const NO_PRESENTATION = {turn_id: ''}

/** Renders a markdown assistant text part. */
export function AhpAssistantText({
  content,
  presentation,
}: {
  content: string
  presentation?: CopilotResultRenderIdentity
}) {
  const presentationRef = useCopilotResultElement(presentation ?? NO_PRESENTATION, 'content', Boolean(presentation))
  const terminalRef = useCopilotResultElement(
    presentation ?? NO_PRESENTATION,
    'terminal',
    Boolean(presentation?.terminal_state && presentation.terminal_state !== 'error'),
  )
  const resultRef = useMergedRefs(presentationRef, terminalRef)
  if (!content?.trim()) return null

  return (
    <div className={clsx('d-flex flex-row flex-items-start gap-2 mb-2', styles.assistantText)}>
      <div className="flex-1 min-width-0" ref={resultRef}>
        <MarkdownRenderer markdown={content} />
      </div>
    </div>
  )
}
